import React from "react";
import Page from "../components/Page";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import LoadingScreen from 'react-loading-screen'
import logo from "assets/img/logo/logo_aig_login-2.png";
import ErrorPage from '../components/ErrorPage'
import Ubicacion from '../components/CotizacionRCAndina/Ubicacion'
import { Alert, } from "reactstrap";

import { apiPost, apiGet } from '../api'

import { urlSaveCarRCA, urlConsultarCedula, urlRecuperarRCA, urlListarProvincias, urlEliminarProducto, ambienteAplicacion } from '../constants/urls'
import DatosEmpresa from '../components/CotizacionRCAndina/DatosEmpresa'
import DatosVehiculo from '../components/CotizacionRCAndina/DatosVehiculo'
import Resumen from '../components/CotizacionRCAndina/Resumen'
import { arraySucursales, formatoReactSelect } from '../redux/selectors/varios'
import { sucursalesFetch } from '../redux/actions/aRamos'
import { listarColoresFetch } from '../redux/actions/aCotizacion'
import { vehiculoConst, Ramos } from '../constants'

const RAMO = Ramos.rcandina

class ContainerRcAndida extends React.Component {
    constructor(props) {
        super(props)
        if (this.props.sucursales) this.props.sucursalesFetch();
        if (this.props.colores.length === 0) this.props.listarColoresFetch();

        this.state = {
            loading: false, validate: false, alert: '',
            idCarrito: '',
            sucursal: '',
            rucEmpresa: '', nomEmpresa: '',
            personeria: '',
            pasoCarrito: '',
            provincias: [], provinciaSelected: '', ciudadSelected: '',
            error: '',
            codProducto: '',
            placa: '',
            resumen: false,
            checkPlaca: false,
            mostrarError: false
        }

    }

    componentDidMount() {
        this.consultarProvincias()

        const param = new URLSearchParams(this.props.location.search);
        let id = param.get('id');
        let paso = param.get('paso');

        if (id) {
            id = id.replace('?id=', '')
            this.setState({ loading: true })
            this.consultarCotizador({ idCarrito: id });
        } else {
            if (!paso) {
                this.setState({ pasoCarrito: 'pantallaDatos' })
                this.props.history.push({
                    pathname: '/rc-andina/cotizador',
                    search: `paso=pantallaDatos`,
                })
            }
            else {
                this.setState({ pasoCarrito: paso })
            }
        }
        if (this.props.sucursales) this.props.sucursalesFetch();
        if (this.props.colores.length === 0) this.props.listarColoresFetch();

    }
    consultarProvincias = async () => {
        let { transaccion, provincias } = await apiGet(`${urlListarProvincias}&ramo=${RAMO}`)
        if (transaccion) {
            provincias = provincias.map(({ id, provNombre, ...res }) => ({ label: provNombre, value: id, ...res }))
            this.setState({ provincias })
        }
        else {
            alert('Recargue la pagina no se cargaron todos los elementos')
        }
    }

    setCheckPlaca = (checkPlaca) => {
        this.setState({ checkPlaca: checkPlaca })
    }

    setMostrarError = (mostrarError) => {
        this.setState({ mostrarError: mostrarError })
    }

    //persona por cedula
    consultaCargarDatos = async ({ rucEmpresa }) => {

        const data = await apiGet(urlConsultarCedula + rucEmpresa)

        console.log('______', data, this.state)
        const { razon_social = '' } = data

        this.setState({ nomEmpresa: razon_social, rucEmpresa })
        setTimeout(() => this.setState({ validate: true }), 100)

    }


    consultarCotizador = async param => {
        const res = await apiPost(urlRecuperarRCA, param)

        // const { transaccion, pasoMayorCodigo, carDatosAsesor, procedencia, errorDescripcion, categorias } = res

        const { transaccion, errorDescripcion, carProductos = [], datosCotiza, idCarrito, datosUbicacion, valorTotal, categorias, procedencia, carDatosAsesor, marcas, pasoMayor, carUrlPdf } = res
        if (transaccion) {
            let pasoCarrito = carProductos.length > 0 ? 'resumen' : 'pantallaDatos'
            if (pasoMayor && (pasoMayor === 3 || pasoMayor === '3')) {
                pasoCarrito = "facturacion"
            }
            const { provincia: provinciaSelected, ciudad: ciudadSelected, direccion } = datosUbicacion

            this.setState({
                carProductos,
                ...datosCotiza,
                idCarrito,
                valorTotal,
                categorias,
                procedencia,
                pasoCarrito,
                provinciaSelected,
                ciudadSelected,
                direccion,
                sucursal: carDatosAsesor.sucursalSeleccionada,
                marcas,
                loading: false,
                carUrlPdf
            })
            console.log('+++++++++++++', this.props)
            //Validar que no venga de facturacion
            //debugger
            const param2 = new URLSearchParams(this.props.location.search);
            let backfacturacion = param2.get('back')
            if (backfacturacion && backfacturacion !== "" && backfacturacion !== null && backfacturacion !== undefined) {
                this.props.history.replace({
                    pathname: '/rc-andina/cotizador',
                    search: `paso=resumen&id=${idCarrito}`,
                })
            }
            else {
                if (pasoCarrito === "facturacion") {
                    this.props.history.push({
                        pathname: '/datos-facturacion',
                        search: `id=${idCarrito}`,
                    })
                }
                else {
                    this.props.history.push({
                        pathname: '/rc-andina/cotizador',
                        search: `paso=${pasoCarrito}&id=${idCarrito}`,
                    })
                }
            }
            //search: `paso=${pasoMayorCodigo}&id=${idCarrito}`,
        } else {
            this.setState({ error: errorDescripcion, loading: false, pasoCarrito: 'pantallaDatos' })
        }

    }

    handleNext = async ({ params, paso }) => {

        const { cliCodigoCore } = this.props
        const { idCarrito, codProducto, pasoCarrito } = this.state
        let param = params
        if (paso === 0) {
            //Crear Nodo carDatosAsesor      
            let arrayDatosAsesor = {
                nombre: `${this.props.datosAsesor.nombres} ${this.props.datosAsesor.apellidos}`,
                codigoCore: this.props.datosAsesor.cliCodigoCore,
                sucursalSeleccionada: params.sucursal,
                ambiente: ambienteAplicacion,
                emailAsesor: this.props.datosAsesor.correo ? this.props.datosAsesor.correo : '',
                brokerRUC: this.props.datosAsesor.brokerRUC ? this.props.datosAsesor.brokerRUC : '',
                brokerNombre: this.props.datosAsesor.brokerNombre ? this.props.datosAsesor.brokerNombre : '',
                brokerCodigo: this.props.datosAsesor.brokerCodigo ? this.props.datosAsesor.brokerCodigo : '',
            }
            param = { ...params, pasoCarrito: 'pantallaDatos', cliCodigoCore, idCarrito, arrayDatosAsesor }
        }
        if (paso === 1) {
            this.setState({ pasoCarrito: 'inicio' })
            param = { ...params, pasoCarrito: 'inicio', codProducto, idCarrito }
        }
        if (paso === 2)
            param = { ...params, pasoCarrito, codProducto, idCarrito }

        console.log('setDataCrearCarrito', param, paso)

        this.setDataCrearCarrito(param, paso)
    }

    setDataCrearCarrito = async (params, paso) => {

        console.log('setDataCrearCarrito22', params, paso);
        let res = await apiPost(urlSaveCarRCA, params)
        console.log('setDataCrearCarrito33', res);
        const cedulaConductor = ''
        const nombreConductor = ''
        let { transaccion, carrito, placa, idCarrito } = res
        if (transaccion) {
            if (paso === 0) {
                const { provincia: provinciaSelected, ciudad: ciudadSelected } = params
                let pasoCarrito = 'inicio'
                if (this.state.resumen) {
                    pasoCarrito = 'resumen'
                }

                this.setState({ loading: false, ...res, pasoCarrito, provinciaSelected, ciudadSelected, ...params, idCarrito, resumen: false })
                this.props.history.push({
                    pathname: '/rc-andina/cotizador',
                    search: `paso=${pasoCarrito}&id=${res.idCarrito}`,
                })
            }
            else if (paso === 1) {


                let datosProducto = { ...vehiculoConst, ...placa.datosVehiculo }

                if (`${datosProducto.marcaCodigo}` === '') datosProducto.marcaEd = true
                if (`${datosProducto.modeloCodigo}` === '') datosProducto.modeloEd = true
                if (`${datosProducto.motor}` === '') datosProducto.motorEd = true
                if (`${datosProducto.chasis}` === '') datosProducto.chasisEd = true
                if (`${datosProducto.anio}` === '') datosProducto.anioEd = true
                if (`${datosProducto.color}` === '') datosProducto.colorEd = true
                if (`${datosProducto.procedenciaCodigo}` === '') datosProducto.procedenciaEd = true
                if (`${datosProducto.categoriaCodigo}` === '') datosProducto.categoriaEd = true

                this.setState({
                    datosProducto,
                    placa: params.placa,
                    ...carrito, ...placa, loading: false,
                    cedulaConductor, nombreConductor,
                    pasoCarrito: 'ingresoData'
                })
                this.props.history.push({
                    pathname: '/rc-andina/cotizador',
                    search: `paso=ingresoData&id=${this.state.idCarrito}`,
                })
            } else if (paso === 2) {

                this.setState({ loading: false, ...res, pasoCarrito: 'resumen', datosProducto: '', nombreConductor, cedulaConductor })
                this.props.history.push({
                    pathname: '/rc-andina/cotizador',
                    search: `paso=resumen&id=${this.state.idCarrito}`,
                })
            }
        } else {
            alert(res.errorDescripcion)
            this.setState({ loading: false })
        }
    }

    toggleLoading = () => this.setState((prevState) => ({ ...prevState, loading: !prevState.loading }))

    handleBack = (params = {}) => {
        const { pasoCarrito } = this.state;
        const { paso = '' } = params

        if (paso && paso === 'inicio') {
            this.props.history.push({
                pathname: '/rc-andina/cotizador',
                search: `paso=pantallaDatos&id=${this.state.idCarrito}`
            })
            return this.setState({ pasoCarrito: 'pantallaDatos', resumen: true })
        }

        console.log('paramsparams', params)

        if (pasoCarrito === 'ingresoData') {
            this.props.history.push({
                pathname: '/rc-andina/cotizador',
                search: `paso=pantallaDatos&id=${this.state.idCarrito}`
            })
            return this.setState({ pasoCarrito: 'pantallaDatos', })
        }
        else if (pasoCarrito === 'resumen') {
            this.props.history.push({
                pathname: '/rc-andina/cotizador',
                search: `paso=ingresoData&id=${this.state.idCarrito}`
            })
            this.setState({ pasoCarrito: 'ingresoData', ...params })
        }

    }
    handleEliminar = async ({ codProducto }) => {
        let url = urlEliminarProducto.replace('{codProducto}', codProducto)
        url = url.replace('{idCarrito}', this.state.idCarrito)
        let res = await apiGet(url)
        console.log(res, url)
        if (!res.transaccion)
            alert('No se pudo eliminar el elemento')
        else {
            this.setState({ carProductos: res.carProductos, valorTotal: res.valorTotal })
        }
    }
    handleAddVehiculo = () => {
        this.props.history.push({
            pathname: '/rc-andina/cotizador',
            search: `paso=inicio&id=${this.state.idCarrito}`
        })
        this.setState({ pasoCarrito: 'inicio', placa: '', codProducto: '', cedulaConductor: '', nombreConductor: '', })
    }

    componentDidUpdate(prevProps, prevState) {
        let { search } = this.props.location

        if (search !== prevProps.location.search) {
            const param = new URLSearchParams(search);
            const paso = param.get('paso');

            if (paso === null) {
                this.setState({ pasoCarrito: 'pantallaDatos', codProducto: '', idCarrito: '', sucursal: '', rucEmpresa: '', nomEmpresa: '', placa: '', provinciaSelected: '', ciudadSelected: '', })
                this.props.history.replace({ pathname: '/rc-andina/cotizador', search: `paso=pantallaDatos` })
            } else {
                this.setState({ pasoCarrito: paso })
            }
        }
    }

    redireccionarFacturacion = () => {
        this.setState({ validate: true });
        this.props.history.push({
            pathname: "/datos-facturacion",
            search: `?id=${this.state.idCarrito}`
        });
    }

    render() {

        console.log('ContainerP', this.props)
        console.log('ContainerS', this.state)

        if (this.state.error)
            return <ErrorPage mainText={this.state.error} />
        const { alert, loading, pasoCarrito } = this.state
        const { arraySucursales } = this.props
        return (
            <main className="bg-light">
                <div className="cr-content container-fluid">
                    <div className="container-body-spaces">
                        <LoadingScreen
                            loading={loading}
                            bgColor="#f1f1f1"
                            spinnerColor="#001871"
                            textColor="#676767"
                            logoSrc={logo}
                            text="Cargando..." >
                            <Page title="Responsabilidad Civil Andina" breadcrumbs={[{ name: "Cotización R.C Andina", active: true }]} >
                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', }} >
                                        <div className="wrapper-step" >
                                            <div className="arrow-steps clearfix-step">
                                                <div className={pasoCarrito !== 'resumen' ? "step current" : 'step'}> {` 1. Cotización `} </div>
                                                <div className={pasoCarrito === 'resumen' ? "step current" : 'step'}> {` 2. Resumen `} </div>
                                                <div className="step"> {` 3. Confirmación `} </div>
                                                <div class="step"> {` 4. Forma de Pago `} </div>
                                                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                                                <div class="step"> {` 6. Emisión `} </div>
                                            </div>
                                        </div>
                                    </div>

                                    {alert && <Alert color="danger">{` ${alert}, recargue la página `}</Alert>}
                                    {pasoCarrito === 'pantallaDatos' &&
                                        <Ubicacion {...this.state} arrayPersoneria={this.props.arrayPersoneria}
                                            handleNext={(e) => { this.setState({ loading: true }); this.handleNext(e) }}
                                            arraySucursales={arraySucursales} />}

                                    {(pasoCarrito === 'inicio' || pasoCarrito === 'ingresoData') &&
                                        <DatosEmpresa {...this.state}
                                            setCheckPlaca={this.setCheckPlaca}
                                            checkPlaca={this.state.checkPlaca}
                                            setMostrarError={this.setMostrarError}
                                            mostrarError={this.state.mostrarError}
                                            handleNext={(e) => { this.setState({ loading: true }); this.handleNext(e) }} />}

                                    {pasoCarrito === 'ingresoData' &&
                                        <DatosVehiculo {...this.state} colores={this.props.colores} handleBack={this.handleBack}
                                            setCheckPlaca={this.setCheckPlaca}
                                            checkPlaca={this.state.checkPlaca}
                                            setMostrarError={this.setMostrarError}
                                            mostrarError={this.state.mostrarError}
                                            handleNext={(params) => { this.setState({ loading: true, }); this.handleNext(params) }} />}

                                    {pasoCarrito === 'resumen' &&
                                        <Resumen {...this.state}
                                            handleBack={this.handleBack}
                                            agregarVehiculo={this.handleAddVehiculo}
                                            handleEliminar={this.handleEliminar}
                                            redireccionar={this.redireccionarFacturacion}
                                        />}

                                </div>
                            </Page>
                        </LoadingScreen>
                    </div>
                </div>
            </main>
        );
    }
}

const mapStateToProps = state => ({

    dataUsuario: state.datosUsuarios,
    sucursales: state.datosSucursales.DataSucursales,
    arraySucursales: arraySucursales(state),
    cliCodigoCore: state.datosUsuarios.dataUsuario.cliCodigoCore,
    colores: formatoReactSelect(state.catalogosCotizacion.colores, 'colCodigoCore', 'colNombre'),
    arrayPersoneria: state.catalogosCotizacion.personeria.tiposIdentificacion,
    datosAsesor: state.datosUsuarios.dataUsuario,
    sucursales: state.datosSucursales.DataSucursales,
});

const mapDispatchToProps = dispatch => {
    return {
        sucursalesFetch: () => dispatch(sucursalesFetch()),
        listarColoresFetch: () => dispatch(listarColoresFetch()),
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(ContainerRcAndida)
);
